import React from "react";
import { useGetTodosQuery } from "../Redux/features/api/apiSlice";

const Footer = ({ setStatus, status }) => {
    const { data: todos } = useGetTodosQuery("All");
    const incompletedTodos = todos?.filter((t) => !t.completed);
    let remaining = null;
    if (incompletedTodos?.length === 0)
        remaining = `${incompletedTodos.length} task`;

    if (incompletedTodos?.length === 1)
        remaining = `${incompletedTodos.length} task`;
    if (incompletedTodos?.length > 1) {
        remaining = `${incompletedTodos.length} tasks`;
    }

    return (
        <div className="mt-4 flex justify-between text-xs text-gray-500">
            <p>{remaining} left</p>
            <ul className="flex space-x-1 items-center text-xs">
                <li
                    className={`cursor-pointer ${
                        status === "All" && "font-bold"
                    }`}
                    onClick={() => setStatus("All")}
                >
                    All
                </li>
                <li>|</li>
                <li
                    className={`cursor-pointer ${
                        status === "Incomplete" && "font-bold"
                    }`}
                    onClick={() => setStatus("Incomplete")}
                >
                    Incomplete
                </li>
                <li>|</li>
                <li
                    className={`cursor-pointer ${
                        status === "Complete" && "font-bold"
                    }`}
                    onClick={() => setStatus("Complete")}
                >
                    Complete
                </li>
                <li></li>
                <li></li>
                <li
                    className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${"bg-green-500"}`}
                    //     onClick={() => handleColorChange("green")}
                ></li>
                <li
                    className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${"bg-red-500"}`}
                    //     onClick={() => handleColorChange("red")}
                ></li>
                <li
                    className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${"bg-yellow-500"}`}
                    //     onClick={() => handleColorChange("yellow")}
                ></li>
            </ul>
        </div>
    );
};

export default Footer;

// colors.includes("red")
